/**
 * assets/analytics.js
 * Thin wrapper around Shopify's native analytics + GA4 + an internal
 * dataLayer, so every section fires ONE consistent event instead of each
 * feature inventing its own tracking call. See README.md → "Analytics event
 * plan" for the full list of event names and payload shapes this expects.
 */
(function () {
  const settings = (window.driedYet && window.driedYet.settings) || {};

  function track(eventName, payload) {
    if (!settings.analyticsEnabled) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, payload));

    if (window.gtag) {
      window.gtag("event", eventName, payload || {});
    }

    // Shopify's native Web Pixels / analytics.js pub-sub, when present.
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === "function") {
      window.Shopify.analytics.publish(eventName, payload || {});
    }

    if (settings.analyticsDebug) {
      // eslint-disable-next-line no-console
      console.log("[Dried Yet Analytics]", eventName, payload);
    }
  }

  window.driedYet = window.driedYet || {};
  window.driedYet.track = track;

  // Generic delegated listeners for the events every section fires the same way.
  document.addEventListener("dyet:add_to_cart", (e) => track("add_to_cart", e.detail));
  document.addEventListener("dyet:remove_from_cart", (e) => track("remove_from_cart", e.detail));
  document.addEventListener("dyet:view_item", (e) => track("view_item", e.detail));
  document.addEventListener("dyet:select_item", (e) => track("select_item", e.detail));
  document.addEventListener("dyet:begin_checkout", (e) => track("begin_checkout", e.detail));
  document.addEventListener("dyet:apply_discount", (e) => track("apply_discount_code", e.detail));
  document.addEventListener("dyet:newsletter_signup", (e) => track("newsletter_signup", e.detail));
  document.addEventListener("dyet:bundle_complete", (e) => track("bundle_complete", e.detail));
  document.addEventListener("dyet:recipe_search", (e) => track("recipe_search", e.detail));
  document.addEventListener("dyet:filter_apply", (e) => track("filter_apply", e.detail));
})();
